import * as React from 'react';
import { useState } from 'react';
import {
  Button, ButtonGroup, Checkbox,
  Dialog, FormControl, FormControlLabel,
  Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField,
  Typography
} from '@mui/material';
import axios from 'axios';
import { getApiBaseUrl } from '../../utils/env';
import { DialogRoot } from './DialogRoot';
import Box from '@mui/material/Box';
import { UploadFile } from '@mui/icons-material';
import { TitleDialog } from './TitleDialog';

const durationOpts = Array.from({ length: 10 }, (_, index) => (index + 1) * 5);

export const VideoClip = ({ open, title, handleClose, video, format }) => {
  const [busy, setBusy] = useState<boolean>();
  const [errorSubmision, setErrorSubmision] = useState<string>();
  const [postSubmit, setPostSubmit] = useState<boolean>();
  const [clipCount, setClipCount] = useState<number>(3);
  const [includeCaption, setIncludeCaption] = useState<boolean>(false);
  const [duration, setDuration] = useState<number>(durationOpts[5]);
  const [clipType, setClipType] = useState<string>(video.duration > 600 ? 'studio+':  'studio');
  const [instruction, setInstruction] = useState<string>('');

  const reClipRequest = async (e) => {
    e.preventDefault();
    setPostSubmit(undefined);
    setErrorSubmision('');
    setBusy(true);
    await axios.post(`${getApiBaseUrl()}/video-clip/${video.domain}/re-clip`, {
      uuid: video.uuid,
      format,
      duration,
      clipCount,
      clipType,
      instruction,
      includeCaption
    }).then(() => {
      setPostSubmit(true);
      setErrorSubmision('');
      setBusy(false);
    })
    .catch(e => {
      setErrorSubmision(e);
      setPostSubmit(false);
      setBusy(false);
    });
  };

  return (
    <Dialog title={title} open={open} onClose={handleClose} fullWidth={true} maxWidth={'sm'}>
      <DialogRoot handleClose={handleClose}>
        <TitleDialog>{title}</TitleDialog>
        <form onSubmit={reClipRequest}>
          <Box sx={{ pl: 4, pr: 4, pb: 4 }}>
            <Grid container spacing={2} style={{ marginTop: 0, minHeight: '400px' }}>
              <Grid item xs={12}>
                {postSubmit &&
                  <Typography color={'green'} fontSize={'12px'}>Instruction successfully
                    submitted</Typography>}
                {!postSubmit &&
                  <Typography color={'red'} fontSize={'12px'}>{errorSubmision}</Typography>}
              </Grid>
              <Grid item xs={6}>
                <ButtonGroup>
                  <FormControl
                    variant="outlined"
                    margin="dense"
                    style={{
                      marginTop: '0px',
                      marginBottom: '0px',
                    }}
                  >
                    <InputLabel>Number of clips to aim for</InputLabel>
                    <Select
                      label={'Number of clips to aim for'}
                      id="clip-count-select"
                      defaultValue={clipCount}
                      onChange={({ target: { value } }) => setClipCount(Number(value))}
                      sx={{
                        height: '43px',
                        width: '200px',
                      }}
                    >
                      {Array.from({ length: 10 }, (_, index) => index + 1).map((num) => (
                        <MenuItem key={num} value={num}>
                          {num}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </ButtonGroup>
              </Grid>
              <Grid item xs={6}>
                <ButtonGroup>

                  <FormControl
                    variant="outlined"
                    margin="dense"
                    style={{
                      marginTop: '0px',
                      marginBottom: '0px',
                    }}
                  >
                    <InputLabel>Duration of clips to aim for</InputLabel>
                    <Select
                      label={'Duration of clips to aim for'}
                      id="clip-duration-select"
                      defaultValue={duration}
                      onChange={({ target: { value } }) => setDuration(Number(value))}
                      sx={{
                        height: '43px',
                        width: '200px',
                      }}
                    >
                      {durationOpts.map((num) => (
                        <MenuItem key={num} value={num}>
                          {num}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </ButtonGroup>
              </Grid>
              <Grid item xs={12}>
                 <FormControlLabel
                    sx={{ marginRight: 0 }}
                    control={<Checkbox checked={includeCaption} onChange={e => setIncludeCaption(e.target.checked)} sx={{ marginRight: 0}} />}
                    label="Include Caption"
                    disabled={format === 'horizontal'}
                  />
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <RadioGroup aria-labelledby="demo-radio-buttons-group-label"
                              name="radio-buttons-group"
                              row>
                    <FormControlLabel
                      value="studio"
                      disabled={video.duration > 600}
                      control={<Radio checked={clipType === 'studio'}
                                      onChange={() => setClipType('studio')}/>}
                      label="Studio"
                    />
                    <FormControlLabel
                      value="studio+"
                      control={<Radio checked={clipType === 'studio+'}
                                      onChange={() => setClipType('studio+')}/>}
                      label="Studio+"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ visibility: clipType === 'studio+' ? 'visible' : 'hidden' }}>
                <FormControl fullWidth>
                  <TextField
                    multiline
                    minRows={3}
                    id="instruction"
                    label="Describe what to look for in this video *"
                    variant="outlined"
                    type={'text'}
                    onChange={({ target: { value } }) => setInstruction(value)}
                    value={instruction}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Grid container justifyContent={'space-between'}>

                  <Button onClick={() => handleClose()}>Cancel</Button>
                  <Button disabled={busy} variant={'contained'} type={'submit'}
                          startIcon={<UploadFile/>}>{ busy ? 'Sending.. ' : 'Send request'}</Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </form>
      </DialogRoot>
    </Dialog>
  );
};
